import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { addCatalogue, addCatalogueTages, getByPk, add_j_CatalogueTages, getCatalogue, getCatalogueByPk, getCatalogueCategories, removeCatelog, updateCatelogStatus, getTagsData, updateCatelog, getsubPlan, updateSubAvilCount, catSubPlans, addNextSubPlan, getAdminCatalogues, getAdminPendingCatalogues, getAdminApporevedCatalogues, getAdminRejectedCatalogues, supplierProfileData, getCatCategoriesCount, getUserPendingCatalogues, getUserApprovedCatalogues, getUserRejectedCatalogues, getAdminExpCatalogues, getUserExpiredCatalogues, getUserDraftCatalogues, freePlan, catMultipleMutation, getAdminScduledCatalogues, getUserScheduledCatalogues, getCatalogueSubCategories, getCatalogueType, getCatalogueTypeOptions, getCatalogueCategoryOptions } from '../queries/addCatalogue.query';
import { Observable } from 'rxjs';
import { pluck } from 'rxjs/operators';
import { CatPopupComponent } from '../pages/cat-popup/cat-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { toPromise } from '@apollo/client/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from 'src/app/core/toast.service';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';


@Injectable()
export class CatalogueService {
  constructor(
    private apollo: Apollo,
    private _dialog: MatDialog,
    private router: Router,
    private http: HttpClient,
    private toast: ToastService,
    private activeRoute: ActivatedRoute
  ) {}

  //   async addCatlog(catData: any): Promise<any> {

  //     catData.description = "lll"
  //    // catData.dental_practice_id ="8099f549-5734-4869-85f6-b0485218d1ff"
  //     const catalogueObj = {catalogueObj:catData}
  //     console.log(catalogueObj)
  //     try {
  //       await this.apollo.use("external")
  //         .mutate({
  //           mutation: addCatalogue,
  //           variables: {catalogueObj},
  //         })
  //         .toPromise();
  //       //this.toast.openSnackBar('Submitted Successfully');
  //       return true;
  //     } catch (err) {
  //       console.log(err);
  //       //this.toast.openSnackBar('You Failed To Submit');
  //       return false;
  //     }
  //   }

  async addCatlog(catalogueObj): Promise<any> {
    try {
      //const catalogueObj = {catalogueObj:catData}
      // console.log(catalogueObj)
      // catData.description = "lll"
      await this.apollo
        .use('external')
        .mutate({
          mutation: addCatalogue,
          variables: { catalogueObj },
        })
        .pipe(pluck('data', 'insert_catalogues_one'))
        .toPromise();

      this.toast.openSnackBar('Catalogue Details Submitted SuccessFully');

      return true;
    } catch (err) {
      console.log(err);
      //this.toast.openSnackBar('You Failed To Submit');
      //return false;

      // this._dialog.open (CatPopupComponent, {
      //   width: '40%',
      //   panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
      //   disableClose: true
      // })
    }
  }

  getAllCatalogues(id: string): Observable<any> {
    return this.apollo
      .use('external')
      .subscribe({
        query: getCatalogue,
        variables: { id },
      })
      .pipe(pluck('data', 'catalogues'));
  }

  adminCatalogues(): Observable<any> {
    return this.apollo
      .use('external')
      .subscribe({
        query: getAdminCatalogues,
      })
      .pipe(pluck('data', 'catalogues'));
  }

  adminPendingCatalogues(): Observable<any> {
    return this.apollo
      .use('external')
      .subscribe({
        query: getAdminPendingCatalogues,
      })
      .pipe(pluck('data', 'catalogues'));
  }

  userPendingCatalogues(id): Observable<any> {
    return this.apollo
      .use('external')
      .subscribe({
        query: getUserPendingCatalogues,
        variables: { id },
      })
      .pipe(pluck('data', 'catalogues'));
  }

  userApprovedCatalogues(id): Observable<any> {
    
    return this.apollo
      .use('external')
      .subscribe({
        query: getUserApprovedCatalogues,
        variables: { id },
      })
      .pipe(pluck('data', 'catalogues'));
  }

  userDraftCatalogues(id): Observable<any> {
    return this.apollo
      .use('external')
      .subscribe({
        query: getUserDraftCatalogues,
        variables: { id },
      })
      .pipe(pluck('data', 'catalogues'));
  }

  userRejectedCatalogues(id): Observable<any> {
    return this.apollo
      .use('external')
      .subscribe({
        query: getUserRejectedCatalogues,
        variables: { id },
      })
      .pipe(pluck('data', 'catalogues'));
  }

  userExpCatalogues(id): Observable<any> {
    return this.apollo
      .use('external')
      .subscribe({
        query: getUserExpiredCatalogues,
        variables: { id },
      })
      .pipe(pluck('data', 'catalogues'));
  }

  userScheduleCatalogues(id): Observable<any> {
    return this.apollo
      .use('external')
      .subscribe({
        query: getUserScheduledCatalogues,
        variables: { id },
      })
      .pipe(pluck('data', 'catalogues'));
  }


  adminApprovedCatalogues(): Observable<any> {
    return this.apollo
      .use('external')
      .subscribe({
        query: getAdminApporevedCatalogues,
      })
      .pipe(pluck('data', 'catalogues'));
  }

  adminRejectedCatalogues(): Observable<any> {
    return this.apollo
      .use('external')
      .subscribe({
        query: getAdminRejectedCatalogues,
      })
      .pipe(pluck('data', 'catalogues'));
  }

  adminExpiredCatalogues(): Observable<any> {
    return this.apollo
      .use('external')
      .subscribe({
        query: getAdminExpCatalogues,
      })
      .pipe(pluck('data', 'catalogues'));
  }

  adminScheduleCatalogues(): Observable<any> {
    return this.apollo
      .use('external')
      .subscribe({
        query: getAdminScduledCatalogues,
      })
      .pipe(pluck('data', 'catalogues'));
  }



  getCatalog(id: string) {
    return this.apollo
      .use('external')
      .subscribe({
        query: getCatalogueByPk,
        variables: { id },
      })
      .pipe(pluck('data', 'catalogues_by_pk'));
  }

  getCatalogueCategories(): Observable<any> {
    return this.apollo
      .use('external')
      .subscribe({
        query: getCatalogueCategories,
      })
      .pipe(pluck('data', 'catalogue_categories'));
  }

  getCatalogueSubCategories(): Observable<any> {
    return this.apollo
      .use('external')
      .subscribe({
        query: getCatalogueSubCategories,
      })
      .pipe(pluck('data', 'catalogue_sub_categories'));
  }
  getCatalogueType(): Observable<any> {
    return this.apollo
      .use('external')
      .subscribe({
        query: getCatalogueType,
      })
      .pipe(pluck('data', 'catalogue_categories'));
  }

  async addCatlogTags(single): Promise<any> {
    //const catalogueObj = {catalogueObj:catData}
    //catData.description = "lll"
    return await this.apollo
      .use('external')
      .mutate({
        mutation: addCatalogueTages,
        variables: { single },
      })
      .pipe(pluck('data', 'insert_catalogue_tags_one'))
      .toPromise();
  }

  async add_j_CatlogTags(single): Promise<any> {
    //const catalogueObj = {catalogueObj:catData}
    // console.log(catalogueObj)
    //catData.description = "lll"
    return await this.apollo
      .use('external')
      .mutate({
        mutation: add_j_CatalogueTages,
        variables: { single },
      })
      .toPromise();
  }

  removeCatalog(id: string): Observable<any> {
    return this.apollo
      .use('external')
      .subscribe({
        query: removeCatelog,
        variables: { id },
      })
      .pipe(pluck('data', 'delete_catalogues'));
  }

  updateCatelogStarus(id, updateObj) {
    //const updateObj = {updateObj:statusData}
    return this.apollo
      .use('external')
      .mutate({
        mutation: updateCatelogStatus,
        variables: { id, updateObj },
      })
      .pipe(pluck('data', 'update_catalogues_by_pk'));
  }

  getByPk(id: string): Observable<any> {
    return this.apollo
      .use('external')
      .query({
        query: getByPk,
        variables: {
          id,
        },
      })
      .pipe(pluck('data', 'catalogues_by_pk'));
  }

  getTags(tagIdArray: any) {
    return this.apollo
      .use('external')
      .subscribe({
        query: getTagsData,
        variables: { tagIdArray },
      })
      .pipe(pluck('data', 'catalogue_tags'));
  }

  updateCatelog(id, updateObj) {
    //const updateObj = {updateObj:statusData}
    return this.apollo
      .use('external')
      .mutate({
        mutation: updateCatelog,
        variables: { id, updateObj },
      })
      .pipe(pluck('data', 'update_catalogues_by_pk'));
  }

  getSubPlan(id: string): Observable<any> {
    return this.apollo
      .subscribe({
        query: getsubPlan,
        variables: { id },
      })
      .pipe(pluck('data', 'client_subscriptions'));
  }

  updatesubAilPlan(cid, sid, subPlanAvailUpdate) {
    //console.log(id)
    //const updateObj = {updateObj:statusData}
    return this.apollo
      .mutate({
        mutation: updateSubAvilCount,
        variables: { cid, sid, subPlanAvailUpdate },
      })
      .pipe(pluck('data', 'update_client_subscriptions'));
  }

  getCataloguesSubPlans(): Observable<any> {
    return this.apollo
      .subscribe({
        query: catSubPlans,
      })
      .pipe(pluck('data', 'subscription_plans'));
  }

  addNextSub(userSubscription): Observable<any> {
    return this.apollo
      .use('external')
      .mutate({
        mutation: addNextSubPlan,
        variables: {
          userSubscription,
        },
      })
      .pipe(pluck('data', 'addUserSubscription'));
  }

  addFreePlan(userSubscription): Observable<any> {
    return this.apollo
      .use('external')
      .mutate({
        mutation: freePlan,
        variables: {
          userSubscription,
        },
      })
      .pipe(pluck('data', 'insert_user_subscriptions_one'));
  }

  //  addNextSub(userSubscription){
  //   console.log(userSubscription)

  //   //const catalogueObj = {catalogueObj:catData}
  //       // console.log(catalogueObj)
  //      // catData.description = "lll"
  //   return  this.apollo.use("external").mutate({
  //     mutation: addNextSubPlan,
  //     variables: {userSubscription}
  //   }).pipe(pluck('data', 'addUserSubscription'))

  //   //this.toast.openSnackBar('added on subscription plan added');

  //   //return true;

  //   // catch (err) {
  //   //         console.log(err);
  //   //         this.toast.openSnackBar('You Failed To Submit');
  //   //          return false;

  //   //           // this._dialog.open (CatPopupComponent, {
  //   //           //   width: '40%',
  //   //           //   panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
  //   //           //   disableClose: true
  //   //           // })

  //   //        }

  // }

  getSupplierDataInfo(id: string): Observable<any> {
    return this.apollo
      .use('external')
      .subscribe({
        query: supplierProfileData,
        variables: { id },
      })
      .pipe(pluck('data', 'dental_suppliers_by_pk'));
  }

  getCataloguesAvailalbility(id: string): Observable<any> {
    return this.apollo
      .use('external')
      .subscribe({
        query: getCatCategoriesCount,
        variables: { id },
      })
      .pipe(pluck('data', 'subscription_plans_catalogues_categories'));
  }

  removeMulCatalogues(idArray) {
    return this.apollo
      .use('external')
      .subscribe({
        query: catMultipleMutation,
        variables: { idArray },
      })
      .pipe(pluck('data', 'catalogues'));
  }

  createSubscription(
    email: string,
    name: string,
    paymentMethodId: string,
    priceId: string
  ): Observable<any> {
    return this.http.post(
      environment.serverPath + '/api/v1/event/create-subscription',
      { email, name, paymentMethodId, priceId }
    );
  }

  updateCard(customerId: string, newPaymentMethodId: string): Observable<any> {
    return this.http.post(
      `${environment.serverPath}/api/v1/event/update-card`,
      {
        customerId,
        newPaymentMethodId,
      }
    );
  }

  cancelSubscription(subscriptionId: string): Observable<any> {
    return this.http.post(
      `${environment.serverPath}/api/v1/event/cancel-subscription`,
      { subscriptionId }
    );
  }

  getCatalogueTypeOptions(): Observable<any> {
    return this.apollo
      .use('external')
      .subscribe({
        query: getCatalogueTypeOptions,
      })
      .pipe(pluck('data', 'catalogue_categories'));
  }

  getCatalogueCategoryOptions(): Observable<any> {
    return this.apollo
      .use('external')
      .subscribe({
        query: getCatalogueCategoryOptions,
      })
      .pipe(pluck('data', 'catalogue_sub_categories'));
  }
}
